export default "__VITE_ASSET__B$sT2dwe__"